import { createFileRoute } from '@tanstack/react-router';
import { MaeWorld } from '@/features/insights/MaeWorld';

export const Route = createFileRoute('/_app/maeworld')({ component: MaeWorld });
